<style scoped lang="stylus">
    .count-chart {
        margin-top:10px
        & > div {
            height: 300px
        }
    }
</style>

<template>
    <div class="count-chart">
        <div :id="id"></div>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import _ from 'lodash'
    import {calcSize} from "@/util";

    export default {
        props: [
            'data'
        ],
        components: {},
        data() {
            return {
                echartFontColor: '#fff',
                echartYLineColor: '#113144',
                echartTopFontColor: '#fff',
                echartXYColor: '#949494',

                id: `id${_.random(111111, 999999)}`,
            };
        },
        created() {

        },
        mounted() {
            this.renderChart()
        },
        computed: {},
        watch: {},
        methods: {
            renderChart() {
                console.log(this.data);
                let xData = [], mData = [], wData = [], apData = []
                this.data.map(item => {
                    xData.push(item.stone_name)
                    mData.push(item.total_money)
                    wData.push(item.total_weight)
                    apData.push(item.avg_price)
                })

                let app = {}
                app.config = {
                    rotate: 90,
                    align: 'left',
                    verticalAlign: 'middle',
                    position: 'insideBottom',
                    distance: 15,
                };


                let labelOption = {
                    normal: {
                        show: false,
                        position: app.config.position,
                        distance: app.config.distance,
                        align: app.config.align,
                        verticalAlign: app.config.verticalAlign,
                        rotate: app.config.rotate,
                        formatter: '{a}  {c}',
                        color: this.echartFontColor,
                        fontSize: 12,
                    }
                };

                let option = {
                    // color: ['#003366', '#006699', '#4cabce', '#e5323e'],
                    grid: {
                        left: 10,
                        right: 10,
                        bottom: 40,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        },
                        textStyle: {
                            fontSize: calcSize(12),
                        }
                    },
                    legend: {
                        data: ['金额', '吨数', '均价'],
                        itemWidth: calcSize(25),
                        itemHeight: calcSize(14),
                        textStyle: {
                            color: this.echartXYColor,
                            fontSize: calcSize(12),
                        }
                    },
                    toolbox: {

                    },
                    calculable: true,
                    xAxis: [
                        {
                            type: 'category',
                            axisTick: {show: false},
                            data: xData,
                            axisLabel: {
                                color: this.echartXYColor,
                                fontSize: calcSize(12),
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                color: this.echartXYColor,
                                fontSize: calcSize(12),
                            },
                            splitLine: {
                                lineStyle: {
                                    color: this.echartYLineColor,
                                }
                            }
                        }
                    ],
                    series: [
                        {
                            name: '金额',
                            type: 'bar',
                            barGap: 0,
                            label: labelOption,
                            data: mData,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#1BA990'},
                                            {offset: 1, color: '#80DCBB'},
                                        ]
                                    )
                                },
                            },
                        },
                        {
                            name: '吨数',
                            type: 'bar',
                            label: labelOption,
                            data: wData,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#1EA4BC'},
                                            {offset: 1, color: '#75B6C8'},
                                        ]
                                    )
                                },
                            },
                        },
                        {
                            name: '均价',
                            type: 'bar',
                            label: labelOption,
                            data: apData,
                            itemStyle: {
                                normal: {
                                    color: new echarts.graphic.LinearGradient(
                                        0, 0, 0, 1,
                                        [
                                            {offset: 0, color: '#19be6b'},
                                            {offset: 1, color: '#29be8b'},
                                        ]
                                    )
                                },
                            },
                        },
                    ]
                };
                let chart = echarts.init(document.getElementById(this.id))
                chart.setOption(option)
            }
        },
    };
</script>
